import React from 'react';
import CheckboxList, { ItemInterface } from '../../../ui/List/Checkbox';

interface Props {
  items: ItemInterface[];
  onClickItem(clicked: ItemInterface): void;
}

const ItemList: React.FC<Props> = ({ items, onClickItem }: Props) => {
  return <CheckboxList items={items} onClick={onClickItem} />;
};

export default ItemList;
